import React from 'react';
import { AnswerLabel } from '../../interfaces/HelpToolTip';
import { Box, Divider, Typography } from '@material-ui/core';
import { RatingAnswerButtonStyles } from '../../styles/ratingButtons';
import { useTranslation } from 'react-i18next';
const RatingAnswerButton = React.memo(React.lazy(() => import('../../components/layouts/RatingAnswerButton')));

interface RatingArea {
  qseq?: number | string;
  hasNoEvidence?: boolean;
  labels?: AnswerLabel[];
  selectedResponse?: string | null;
  isValidating?: boolean;
  onAnswer: (data: string, qseq?: number | string) => void;
}

const update = (prev: RatingArea, next: RatingArea): boolean => {
  return prev.selectedResponse === next.selectedResponse && prev.isValidating === next.isValidating;
};

const RatingButtons = ({
  qseq,
  hasNoEvidence,
  labels,
  selectedResponse,
  isValidating,
  onAnswer,
}: RatingArea): JSX.Element => {
  const classes = RatingAnswerButtonStyles({ variant: 'VA' });
  const { t } = useTranslation();
  return (
    <>
      <Box
        className={`${classes.answerBlock} ${hasNoEvidence ? classes.gridColumns6 : classes.gridColumns5}`}
        id="answers"
        key={qseq}>
        {labels &&
          labels.map((item: AnswerLabel, index: number) => {
            if (item.value === '0') {
              return (
                <Box className={classes.flexRow} key={`${index}_${item.value}`} role="gridcell">
                  <Divider
                    aria-hidden="true"
                    className={`${classes.divider} ${hasNoEvidence ? '' : classes.displayNone}`}
                  />
                  <Box key={item.value} className={`${hasNoEvidence ? '' : classes.displayNone}`}>
                    <RatingAnswerButton
                      qseq={qseq}
                      content={item}
                      selectedResponse={selectedResponse}
                      moveToNextQuestion={onAnswer}
                      showLabel={false}
                      isValidating={isValidating}
                    />
                  </Box>
                </Box>
              );
            }

            return (
              <Box className={classes.VAButtons} key={`${index}_${item.value}`} role="gridcell">
                <RatingAnswerButton
                  qseq={qseq}
                  content={item}
                  selectedResponse={selectedResponse}
                  moveToNextQuestion={onAnswer}
                  showLabel={false}
                  isValidating={isValidating}
                />
              </Box>
            );
          })}
      </Box>

      {isValidating && !selectedResponse && (
        <Box className={classes.errorText} pl={2}>
          <Typography>{t('enterResponse')}</Typography>
        </Box>
      )}
    </>
  );
};

export default React.memo(RatingButtons, update);
